import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin.js";

gsap.registerPlugin(ScrollToPlugin);

// Responsive images + Lazy loading
document.createElement('picture');
require('picturefill');
// `object-fit` polyfill
// https://github.com/aFarkas/lazysizes/tree/gh-pages/plugins/object-fit
require('lazysizes/plugins/object-fit/ls.object-fit');
require('lazysizes/plugins/parent-fit/ls.parent-fit');
require('lazysizes/plugins/respimg/ls.respimg');
require('lazysizes');


import video from './video'
import grid from './motion'
import epp from './epp'
import denimFullCircle from './denim-full-circle'

video.init()
grid.init()
epp.init()
denimFullCircle.init()

import wcdPopup from './modal/wcd-popup'
wcdPopup.init()




const $ = window.jQuery
import selectize from 'selectize'

jQuery('body').on('change', 'input[type=checkbox]', function() {
  let $checkbox = jQuery(this)
  $checkbox.parent().toggleClass('checked', $checkbox.is(':checked'))
})

// Pagination script for news post grid. Originally embedded in the post content
if (document.body.classList.contains('page-template-page-spotlight')) {
  jQuery("#next").click(function (event) {
    var items = jQuery('.news-item:visible').hide().last();
    var nextItems = items.nextAll().slice(0, 10);

    if (nextItems.length === 0) {
      nextItems = jQuery(".news-item").slice(0, 10);
    }

    nextItems.show();

    if (jQuery(".news-item:first").is(":visible") == true) {
      jQuery('.back-news').hide();
    }
    else {
      jQuery('.back-news').show();
    }

    if (jQuery(".news-item").filter(":last").is(":visible") == true) {
      jQuery('.forward-news').hide();
    }
    else {
        jQuery('.forward-news').show();
    }
  });

  jQuery("#prev").click(function (event) {

    var items = jQuery('.news-item:visible').hide().first();
    var nextItems = items.prevAll().slice(0, 11);

    if (nextItems.length === 0) {
     nextItems = jQuery(".news-item").slice(0, 11);
    }

    nextItems.show();

    if (jQuery(".news-item:first").is(":visible") == true) {
      jQuery('.back-news').hide();
      jQuery("#news-list .news-item:nth-child(12)").show();
    }
    else {
      jQuery('.back-news').show();
    }

    if (jQuery(".news-item").filter(":last").is(":visible") == true) {
      jQuery('.forward-news').hide();
    }
    else {
      jQuery('.forward-news').show();
    }
  });
}


const viewMoreBtns = Array.prototype.slice.call(document.querySelectorAll('.js-view-more'), 0)
viewMoreBtns.forEach((viewMoreBtn) => {
  const viewMoreContent = viewMoreBtn.parentNode.querySelector('.more-wrapper')
  viewMoreBtn.addEventListener('click', function(e) {

    e.preventDefault()
    const contentRect = viewMoreContent.getBoundingClientRect()
    const scrollDistance = contentRect.height / 2

    gsap.to(viewMoreContent, { duration: .5, scrollTo: { y: `+=${scrollDistance}`, x: 0}, ease: "power3.out"  })
  })
})


const navbarToggle = document.querySelector('.navbar-toggle')
const navbarCollapse = document.querySelector('.navbar-collapse')
navbarToggle.addEventListener('click', function() {
  if (navbarCollapse.classList.contains('in')) {
    navbarCollapse.classList.remove('collapse')
    navbarCollapse.classList.remove('in')
    return;
  }

  navbarCollapse.classList.add('collapse')
  navbarCollapse.classList.add('in')
})

// import popup from './popup'
// popup.init()


//tracking framework
var gtmEvents = {
    pageTracker: null,
    init: function (document) {
        document.find("a[data-ga-category]").click(this.trackLink);
    },
    trackLink: function (e) {
      console.log(e);
        if (dataLayer) {
            var link = jQuery(this);
            var label = link.attr("data-ga-label");
            var action = link.attr("data-ga-action");
            var category = link.attr("data-ga-category");
            dataLayer.push({
              'event' : 'GAEvent',
              'eventCategory' : category,
              'eventAction' : action,
              'eventLabel' : label
            });

        }
        else {
          console.log('dataLayer not found!');
        }
    }
};
import modals from './modal'
modals.init()

import recycleDenim from './modal/recycle-denim'
recycleDenim.init()
jQuery(document).ready(function () { gtmEvents.init(jQuery("html")); });
